import { Card, Loading, isSuccess, useToasts } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useProductTranslationsQuery } from "../shared/api/productTranslationsQueries";
import { productTranslationsService } from "../shared/api/productTranslationsService";
import { ProductTranslationFormValues } from "../shared/types/productTranslation";
import { ProductTranslationsForm } from "./ProductTranslationsForm";

const StyledCard = styled(Card)`
	margin: ${({ theme }) => theme.spacing(6)};
`;

export const ProductTranslationsPage: FC = () => {
	const { showToast } = useToasts();
	const queryClient = useQueryClient();
	const { t } = useTranslation();
	const { data, isLoading } = useProductTranslationsQuery();

	const updateTranslations = useCallback(
		async (values: ProductTranslationFormValues) => {
			const response = await productTranslationsService.update(values);

			if (isSuccess(response)) {
				showToast({
					body: t("Product translations were saved."),
					title: t("Product translations"),
					type: "success",
				});
				await queryClient.invalidateQueries({ queryKey: productTranslationsService.overviewKey });
			}
		},
		[queryClient, showToast, t],
	);

	return (
		<StyledCard>
			{isLoading && <Loading />}
			{!isLoading && data && (
				<ProductTranslationsForm translations={{ translations: data.translations }} handleSave={updateTranslations} />
			)}
		</StyledCard>
	);
};
